import { Component } from '@angular/core';

@Component({
  selector: 'app-power',
  templateUrl: './power.component.html',
  styleUrls: ['./power.component.scss'],
  standalone:false
})
export class PowerComponent {
  powerAppUrl: string = 'https://surface-prod.crm.dynamics.com/main.aspx?appid=0607caf1-ca24-f011-8c4e-6045bd084d01&pagetype=entitylist&etn=new_powercapacity&viewid=a9b5a9e6-5321-f011-998a-000d3a785fb5&viewType=1039&lid=1745944995451';  
}
